module.exports = __webpack_public_path__ + "img/banner-landingpage-campaign01-fase02-01aquiestamosdenuevo.299cf947.jpg";